import { render, staticRenderFns } from "./SocialRule.vue?vue&type=template&id=b4a0d20c&scoped=true"
import script from "./SocialRule.vue?vue&type=script&lang=js"
export * from "./SocialRule.vue?vue&type=script&lang=js"
import style0 from "./SocialRule.vue?vue&type=style&index=0&id=b4a0d20c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a0d20c",
  null
  
)

export default component.exports